// Typelizer digest 7f8a71d15b56b0a7c025e0945dee9e18
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/cash_accounts/:cash_account_id/cash_counts */
  create: (
    params: { cashAccountId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/cash_accounts/:cash_account_id/cash_counts', params, options),
    method: 'post',
  }),
}
